import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import InlineDealer from "./InlineDealer";
import './InlineDealerRow.scss';

interface Data {
    paragraphById: {
        fieldVarTimeframeTitle: string;
        fieldDealers: Array<{
            targetId: string;
        }>;
    }
}

class InlineDealerRowQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
    query paragraphById($id: String!) {
        paragraphById(id: $id) {
            ... on Paragraph {
                ... on Paragraph {
                    ... on ParagraphComponentTopDealers {
                        fieldVarTimeframeTitle
                        fieldLastUpdated
                        fieldDealers {
                            targetId
                        }
                    }
                }
            }
        }
    }
`;

const getTitle = (title, field) => {
    if (!(field && field.fieldLastUpdated)) return title;

    let updatedTitle = title;
    if (title.startsWith('Prior Month:')) {
        updatedTitle = updatedTitle.replace('Prior Month:', `${field.fieldLastUpdated}:`);
    }
    if (title.startsWith('YTD:')) {
        updatedTitle = updatedTitle.replace('YTD:', `YTD (${field.fieldLastUpdated}):`);
    }

    return updatedTitle;
};

const InlineDealerRow = ({id, group, headline, gridType}) => (
    <InlineDealerRowQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error || !data.paragraphById) return <div>{error || null}</div>;

            const field = data.paragraphById;

            // Hide non-matching groups if a group is selected
            if (group && group !== field.fieldVarTimeframeTitle) return null;

            const baseClass = gridType === 'vertical' ? 'inlineDealerColumn' : 'inlineDealerRow';

            return (
                <div className={baseClass}>
                    <h3 className={`${baseClass}__title`}>
                        {getTitle(headline || field.fieldVarTimeframeTitle, field)}
                    </h3>
                    <div className={`${baseClass}__items`}>
                        {field.fieldDealers && field.fieldDealers.map((dealer, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <InlineDealer key={`${dealer.targetId}_${index}`} id={`${dealer.targetId}`} count={index+1}/>
                        ))}
                    </div>
                </div>
            );
        }}
    </InlineDealerRowQuery>
);

InlineDealerRow.propTypes = {
    id: PropTypes.number.isRequired,
    group: PropTypes.string,
    headline: PropTypes.string,
    gridType: PropTypes.string
};

InlineDealerRow.defaultProps = {
    group: '',
    headline: '',
    gridType: 'horizontal'
};

export default InlineDealerRow;



// WEBPACK FOOTER //
// ./frontend/components/InlineDealer/InlineDealerRow.jsx